// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { FaBars } from "react-icons/fa";
// import { FiX } from "react-icons/fi";
// import "../navbar/Header.css";
// import { GoChevronDown } from "react-icons/go";
// import { IoIosArrowForward } from "react-icons/io";

// const Header = () => {
//   const location = useLocation();
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const [categories, setCategories] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [worksImages, setWorksImages] = useState({});
//   const isActive = (path) => {
//     return location.pathname === path ? "active" : "";
//   };

//   useEffect(() => {
//     // Fetch categories from the API
//     const fetchCategories = async () => {
//       const response = await fetch(
//         "https://vogelkoparchitects.com/api/api/categories/",
//       );
//       const data = await response.json();
//       setCategories(data);
//     };

//     // Fetch projects from the API
//     const fetchProjects = async () => {
//       const response = await fetch(
//         "https://vogelkoparchitects.com/api/api/projects/",
//       );
//       const data = await response.json();
//       setProjects(data);
//     };

//     fetchCategories();
//     fetchProjects();
//   }, []);
//   useEffect(() => {
//     const handleScroll = () => {
//       const offset = window.scrollY;
//       setScrolled(offset > 100);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);
//   useEffect(() => {
//     // Once categories and projects are fetched, we need to group projects by category
//     const groupedImages = {};

//     categories.forEach((category) => {
//       // Filter projects by category ID
//       const filteredProjects = projects.filter(
//         (project) => project.category.id === category.id,
//       );

//       // Create an array of images for each category
//       groupedImages[category.title] = filteredProjects.map((project) => ({
//         src: project.project_images[0]?.image, // Use the first project image
//         link: `/Residential1/${project.id}`, // Link to the project page
//       }));
//     });

//     setWorksImages(groupedImages);
//   }, [categories, projects]);

//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [activeSubDropdown, setActiveSubDropdown] = useState(null);
//   const [hoveredItem, setHoveredItem] = useState("Residential");

//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen(!isMobileMenuOpen);
//     setActiveDropdown(null); // Close any open dropdowns when toggling mobile menu
//   };

//   const handleDropdownClick = (dropdown) => {
//     setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
//     setActiveSubDropdown(null); // Reset sub-dropdown when changing main dropdown
//   };

//   const handleSubDropdownClick = (subDropdown) => {
//     if (window.innerWidth <= 991) {
//       setActiveSubDropdown(
//         activeSubDropdown === subDropdown ? null : subDropdown,
//       );
//     }
//   };

//   const handleDropdownHover = (item) => {
//     if (window.innerWidth > 991) {
//       setHoveredItem(item);
//     }
//   };

//   const handleDropdownLeave = () => {
//     if (window.innerWidth > 991) {
//       setHoveredItem("Residential");
//     }
//   };
//   const username = localStorage.getItem("username");
//   return (
//     <>
//       <div
//         className={`site-mobile-menu site-navbar-target ${
//           isMobileMenuOpen ? "active" : ""
//         }`}
//         data-spy="scroll"
//         data-target=".site-navbar-target"
//         data-offset="300"
//       >
//         <div className="site-mobile-menu-header">
//           <div
//             className="site-mobile-menu-close mt-3"
//             onClick={toggleMobileMenu}
//           >
//             <span className="icon-close2 js-menu-toggle">
//               <FiX />
//             </span>
//           </div>
//         </div>
//         <div className="mt-5">
//           <ul className="site-menu main-menu js-clone-nav mr-auto d-lg-none">
//             <li className="has-children">
//               <Link to="/">Home</Link>
//             </li>
//             <li
//               className="has-children"
//               onClick={() => handleDropdownClick("about")}
//             >
//               <Link to="/philosophy">About us</Link>
//               {activeDropdown === "about" && (
//                 <ul className="dropdown-menu" style={{ minWidth: "233px" }}>
//                   <li>
//                     <Link to="/philosophy" className="dropdown-link">
//                       <div className="image-card-about-dropdown">
//                         <img
//                           src="assets/img/about/Philosophy.jpeg"
//                           className="about-img"
//                           alt="Philosophy"
//                         />
//                       </div>
//                       Philosophy
//                     </Link>
//                   </li>
//                   <li>
//                     <Link to="/team" className="dropdown-link">
//                       <div className="image-card-about-dropdown">
//                         <img
//                           src="assets/img/about/team.jpeg"
//                           className="about-img"
//                           alt="Team"
//                         />
//                       </div>
//                       Team
//                     </Link>
//                   </li>
//                   <li>
//                     <Link to="/press" className="dropdown-link">
//                       <div className="image-card-about-dropdown">
//                         <img
//                           src="assets/img/about/press.jpeg"
//                           className="about-img"
//                           alt="Press"
//                         />
//                       </div>
//                       Press
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>
//             <li
//               className="has-children"
//               onClick={() => handleDropdownClick("works")}
//             >
//               <Link to="/works">Works</Link>
//               {activeDropdown === "works" && (
//                 <ul
//                   className="dropdown-menu"
//                   style={{
//                     minWidth: "233px",
//                     backgroundColor: "rgba(0, 0, 0, 0.7)",
//                   }}
//                 >
//                   {Object.keys(worksImages).map((key) => (
//                     <li key={key} onClick={() => handleSubDropdownClick(key)}>
//                       <Link to="/works" className="dropdown-link">
//                         {key}
//                       </Link>
//                       {activeSubDropdown === key && (
//                         <div className="image-card">
//                           {worksImages[key].map((image, index) => (
//                             <img
//                               key={index}
//                               src={image.src}
//                               alt={`${key} ${index}`}
//                             />
//                           ))}
//                         </div>
//                       )}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </li>

//             <li className="has-children">
//               <Link to="/Productcategory">E com</Link>
//             </li>

//             <li className="has-children">
//               <Link to="/cart">Cart</Link>
//             </li>
//             <li className="has-children">
//               <Link to="/track-order">Track Order</Link>
//             </li>
//             <li className="has-children">
//               <Link to="/contact">Contact us</Link>
//             </li>
//             <li>
//               {username ? (
//                 <div className="header_login">
//                   <Link className={isActive("/AuthForm")} to="/AuthForm">
//                     <span>Hi, {username}</span>
//                   </Link>
//                 </div>
//               ) : (
//                 <Link className={isActive("/AuthForm")} to="/AuthForm">
//                   Signup/Login
//                 </Link>
//               )}
//             </li>
//           </ul>
//         </div>
//       </div>

//       <header
//         className={`site-navbar py-0 py-md-4 site-navbar-target scrolled${
//           scrolled ? "scrolled" : ""
//         }`}
//         role="banner"
//       >
//         <div className="container-test">
//           <div className="logo-test mt-3">
//             <h1 className="mb-0 site-logo">
//               <Link to="/" className="text-black h2 mb-0">
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "row",
//                     alignItems: "center",
//                   }}
//                 >
//                   <div>
//                     <h1
//                       className="sitename"
//                       style={{ color: scrolled ? "#292974" : "#fff" }}
//                     >
//                       VOGELKOP ARCHITECTS
//                     </h1>
//                     <span
//                       className="subtext"
//                       style={{
//                         color: scrolled ? "#292974" : "#fff",
//                         display: "block",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       architecture | interior design | landscape
//                     </span>
//                   </div>
//                   <img
//                     src="assets/img/logo.png"
//                     alt="Logo"
//                     className="logo-img"
//                   />
//                 </div>
//               </Link>
//             </h1>
//           </div>

//           <div
//             className="pb-3 d-lg-none"
//             style={{
//               position: "relative",
//               top: "3px",
//               width: "20px",
//               marginLeft: "85px",
//             }}
//           >
//             <button
//               className="site-menu-toggle js-menu-toggle"
//               onClick={toggleMobileMenu}
//             >
//               <span className={`icon-menu h3 ${scrolled ? "scrolled" : ""}`}>
//                 <FaBars />
//               </span>
//             </button>
//           </div>

//           <div className="menu-test d-none d-xl-block">
//             <nav
//               className="site-navigation position-relative text-right d-flex flex-row"
//               role="navigation"
//             >
//               <ul className="site-menu main-menu js-clone-nav mr-auto d-none d-lg-block">
//                 <li className="has-children">
//                   <Link
//                     to="/"
//                     className="nav-link underline default-active"
//                     style={{
//                       fontWeight: "500",
//                       fontSize: "19px",
//                       lineHeight: "21px",
//                       textTransform: "lowercase",
//                     }}
//                   >
//                     Home
//                   </Link>
//                 </li>
//                 <li className="has-children">
//                   <Link
//                     className="nav-link underline"
//                     to="/philosophy"
//                     style={{
//                       fontWeight: "500",
//                       fontSize: "19px",
//                       lineHeight: "21px",
//                       textTransform: "lowercase",
//                     }}
//                   >
//                     About us
//                   </Link>
//                 </li>
//                 <li className="has-children">
//                   <Link
//                     className="nav-link underline"
//                     to="#"
//                     style={{
//                       fontWeight: "500",
//                       fontSize: "19px",
//                       lineHeight: "21px",
//                       textTransform: "lowercase",
//                     }}
//                   >
//                     About us <GoChevronDown />
//                   </Link>
//                   <ul
//                     className="dropdown-menu"
//                     id="about-dropdown"
//                     style={{ padding: "0px", minWidth: "0px" }}
//                   >
//                     <li
//                       onMouseEnter={() => handleDropdownHover("about")}
//                       onMouseLeave={handleDropdownLeave}
//                     >
//                       <div className="image-card-about">
//                         <Link to="/philosophy">
//                           <div className="image-card-about-dropdown">
//                             <img
//                               src="assets/img/about/Philosophy.jpeg"
//                               className="about-img"
//                               alt="Philosophy"
//                             />
//                             <p>Philosophy</p>
//                           </div>
//                         </Link>
//                         <Link to="/team">
//                           <div className="image-card-about-dropdown">
//                             <img
//                               src="assets/img/about/team.jpeg"
//                               className="about-img"
//                               alt="Team"
//                             />
//                             <p>Team</p>
//                           </div>
//                         </Link>
//                         <Link to="/press">
//                           <div className="image-card-about-dropdown">
//                             <img
//                               src="assets/img/about/press.jpeg"
//                               className="about-img"
//                               alt="Press"
//                             />
//                             <p>Press</p>
//                           </div>
//                         </Link>
//                       </div>
//                     </li>
//                   </ul>
//                 </li>

//                 <li className="has-children">
//                   <Link
//                     className="nav-link underline"
//                     to="/works"
//                     style={{
//                       fontWeight: "500",
//                       fontSize: "19px",
//                       lineHeight: "21px",
//                       textTransform: "lowercase",
//                     }}
//                   >
//                     Works <GoChevronDown />
//                   </Link>
//                   <ul className="dropdown-menu" id="works-dropdown">
//                     <div className="dropdown-content">
//                       <div className="dropdown-list">
//                         {Object.keys(worksImages).map((key) => (
//                           <li
//                             key={key}
//                             className="dropdown-item"
//                             onMouseEnter={() => handleDropdownHover(key)}
//                           >
//                             <Link to="/works" className="dropdown-link">
//                               {key} <IoIosArrowForward />
//                             </Link>
//                           </li>
//                         ))}
//                       </div>
//                       <div className="dropdown-images">
//                         {worksImages[hoveredItem]
//                           ?.slice(-9) // Get the last 6 images
//                           .reverse() // Reverse the order of the last 6 images
//                           .map((image, index) => (
//                             <Link to={image.link} key={index}>
//                               <img
//                                 src={image.src}
//                                 alt={`${hoveredItem} ${index}`}
//                               />
//                             </Link>
//                           ))}
//                       </div>
//                     </div>
//                   </ul>
//                 </li>
//                 <li className="has-children">
//                   <Link
//                     style={{
//                       fontWeight: "500",
//                       fontSize: "19px",
//                       lineHeight: "21px",
//                       textTransform: "lowercase",
//                     }}
//                     className="nav-link underline"
//                     to="/gallery"
//                   >
//                     VA Aesthetics
//                   </Link>
//                 </li>
//                 <li className="has-children">
//                   <Link
//                     style={{
//                       fontWeight: "500",
//                       fontSize: "19px",
//                       lineHeight: "21px",
//                       textTransform: "lowercase",
//                     }}
//                     className="nav-link underline"
//                     to="/Productcategory"
//                   >
//                     E com
//                   </Link>
//                 </li>
//                 <li className="has-children">
//                   <Link
//                     style={{
//                       fontWeight: "500",
//                       fontSize: "19px",
//                       lineHeight: "21px",
//                       textTransform: "lowercase",
//                     }}
//                     className="nav-link underline"
//                     to="/cart"
//                   >
//                     Cart
//                   </Link>
//                 </li>
//                 <li className="has-children">
//                   <Link
//                     style={{
//                       fontWeight: "500",
//                       fontSize: "19px",
//                       lineHeight: "21px",
//                       textTransform: "lowercase",
//                     }}
//                     className="nav-link underline"
//                     to="/track-order"
//                   >
//                     Track order
//                   </Link>
//                 </li>
//                 <li>
//                   {username ? (
//                     <div className="header_login">
//                       <Link className={isActive("/AuthForm")} to="/AuthForm">
//                         <span>Hi, {username}</span>
//                       </Link>
//                     </div>
//                   ) : (
//                     <Link
//                       className={isActive("/AuthForm")}
//                       to="/AuthForm"
//                       style={{
//                         fontWeight: "500",
//                         fontSize: "19px",
//                         lineHeight: "21px",
//                         textTransform: "lowercase",
//                       }}
//                     >
//                       Signup/Login
//                     </Link>
//                   )}
//                 </li>
//                 <li className="has-children">
//                   <Link
//                     style={{
//                       fontWeight: "500",
//                       fontSize: "19px",
//                       lineHeight: "21px",
//                       textTransform: "lowercase",
//                     }}
//                     className="nav-link underline"
//                     to="/contact"
//                   >
//                     Contact us
//                   </Link>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </div>
//       </header>
//     </>
//   );
// };
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { GoChevronDown } from "react-icons/go";
import axios from "axios";
import "../navbar/Header.css";
import "./Header.css";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [worksCategories, setWorksCategories] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Fetch works categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://vogelkoparchitects.com/api/api/categories/"
        );
        setWorksCategories(response.data);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setActiveDropdown(null);
  };

  const handleDropdownToggle = (dropdown) => {
    if (window.innerWidth <= 991) {
      setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
    }
  };

  const username = localStorage.getItem("username");

  const handleLogout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  return (
    <>
      {/* Mobile Menu */}
      <div
        className={`site-mobile-menu site-navbar-target ${
          isMobileMenuOpen ? "active" : ""
        }`}
      >
        <div className="site-mobile-menu-header">
          <div
            className="site-mobile-menu-close mt-3"
            onClick={toggleMobileMenu}
          >
            <span className="icon-close2 js-menu-toggle">
              <FiX />
            </span>
          </div>
        </div>
        <div className="mt-5">
          <ul className="site-menu main-menu js-clone-nav mr-auto d-lg-none">
            <li>
              <Link to="/" onClick={toggleMobileMenu}>
                Home
              </Link>
            </li>

            {/* About Us Dropdown */}
            <li className="has-children">
              <div
                className="dropdown-toggle"
                onClick={() => handleDropdownToggle("about")}
              >
                <Link to="#">About Us</Link>
                <GoChevronDown />
              </div>
              {activeDropdown === "about" && (
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/press" onClick={toggleMobileMenu}>
                      Press
                    </Link>
                  </li>
                  <li>
                    <Link to="/team" onClick={toggleMobileMenu}>
                      Team
                    </Link>
                  </li>
                  <li>
                    <Link to="/philosophy" onClick={toggleMobileMenu}>
                      Philosophy
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Works Dropdown with Dynamic Categories */}
            <li className="has-children">
              <div
                className="dropdown-toggle"
                onClick={() => handleDropdownToggle("works")}
              >
                <Link to="/works">WORKS</Link>
                <GoChevronDown />
              </div>
              {activeDropdown === "works" && (
                <ul className="dropdown-menu">
                  {worksCategories.map((category) => (
                    <li key={category.id}>
                      <Link 
                        to={`/project-detail/category/${category.id}`} 
                        onClick={toggleMobileMenu}
                      >
                        {category.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            {/* VA Aesthetics Dropdown with Signup/Login */}
            <li className="has-children">
              <div
                className="dropdown-toggle"
                onClick={() => handleDropdownToggle("va-aesthetics")}
              >
                <Link to="/gallery">VA Aesthetics</Link>
                <GoChevronDown />
              </div>
              {activeDropdown === "va-aesthetics" && (
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/gallery" onClick={toggleMobileMenu}>
                      Gallery
                    </Link>
                  </li>
                  <li>
                    <Link to="/Productcategory" onClick={toggleMobileMenu}>
                      Products
                    </Link>
                  </li>
                  <li>
                    <Link to="/cart" onClick={toggleMobileMenu}>
                      Cart
                    </Link>
                  </li>
                  <li>
                    <Link to="/track-order" onClick={toggleMobileMenu}>
                      Track Order
                    </Link>
                  </li>
                  <li>
                    <Link to="/myorders" onClick={toggleMobileMenu}>
                      My Orders
                    </Link>
                  </li>
                  <li style={{ borderTop: "1px solid #666", margin: "5px 0" }}></li>
                  {!username ? (
                    <>
                      <li>
                        <Link to="/AuthForm" onClick={toggleMobileMenu}>
                          Signup
                        </Link>
                      </li>
                      <li>
                        <Link to="/AuthForm" onClick={toggleMobileMenu}>
                          Login
                        </Link>
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        <Link to="/AuthForm" onClick={toggleMobileMenu}>
                          Profile
                        </Link>
                      </li>
                      <li>
                        <button
                          onClick={() => {
                            handleLogout();
                            toggleMobileMenu();
                          }}
                          style={{
                            width: "100%",
                            textAlign: "left",
                            background: "none",
                            border: "none",
                            padding: "8px 20px",
                            cursor: "pointer",
                            fontSize: "14px",
                            color: "#ffffff"
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#666666";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                          }}
                        >
                          Logout
                        </button>
                      </li>
                    </>
                  )}
                </ul>
              )}
            </li>

            <li>
              <Link to="/contact" onClick={toggleMobileMenu}>
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Desktop Header */}
      <header
        className={`site-navbar py-0 site-navbar-target ${
          scrolled ? "scrolled" : ""
        }`}
        role="banner"
      >
        <div className="container-test">
          <div className="logo-test">
            <h1 className="mb-0 site-logo">
              <Link to="/" className="text-black h2 mb-0">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <h1
                      className="sitename"
                      style={{ color: scrolled ? "#292974" : "#fff", lineHeight: "1.2", whiteSpace: "nowrap" }}
                    >
                      VOGELKOP ARCHITECTS
                    </h1>
                    <span
                      className="subtext"
                      style={{
                        color: scrolled ? "#292974" : "#fff",
                        display: "block",
                        whiteSpace: "nowrap",
                        marginTop: "5px",
                        fontSize: "0.85rem"
                      }}
                    >
                      architecture | interior design | landscape
                    </span>
                  </div>
                </div>
              </Link>
            </h1>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="pb-3 d-lg-none mobile-toggle">
            <button
              className="site-menu-toggle js-menu-toggle"
              onClick={toggleMobileMenu}
            >
              <span className={`icon-menu h3 ${scrolled ? "scrolled" : ""}`}>
                <FaBars />
              </span>
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="menu-test d-none d-lg-block">
            <nav className="site-navigation" role="navigation">
              <ul className="site-menu main-menu">
                <li className="nav-item">
                  <Link to="/" className="nav-link">
                    Home
                  </Link>
                </li>

                {/* About Us Dropdown */}
                <li className="has-children">
                  <Link to="#" className="nav-link">
                    About Us <GoChevronDown />
                  </Link>
                  <ul className="dropdown">
                    <li>
                      <Link to="/press">Press</Link>
                    </li>
                    <li>
                      <Link to="/team">Team</Link>
                    </li>
                    <li>
                      <Link to="/philosophy">Philosophy</Link>
                    </li>
                  </ul>
                </li>

                {/* Works Dropdown with Dynamic Categories */}
                <li className="has-children">
                  <Link to="/works" className="nav-link">
                    Works <GoChevronDown />
                  </Link>
                  <ul className="dropdown">
                    {worksCategories.map((category) => (
                      <li key={category.id}>
                        <Link to={`/project-detail/category/${category.id}`}>
                          {category.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>

                {/* VA Aesthetics Dropdown with Signup/Login */}
                <li className="has-children">
                  <Link to="/gallery" className="nav-link">
                    VA Aesthetics <GoChevronDown />
                  </Link>
                  <ul className="dropdown">
                    <li>
                      <Link to="/gallery">Gallery</Link>
                    </li>
                    <li>
                      <Link to="/Productcategory">Products</Link>
                    </li>
                    <li>
                      <Link to="/cart">Cart</Link>
                    </li>
                    <li>
                      <Link to="/track-order">Track Order</Link>
                    </li>
                    <li>
                      <Link to="/myorders">My Orders</Link>
                    </li>
                    
                    {/* Divider */}
                    <li style={{ borderTop: "1px solid #666", margin: "5px 0" }}></li>
                    
                    {!username ? (
                      <>
                        <li>
                          <Link to="/AuthForm">Signup</Link>
                        </li>
                        <li>
                          <Link to="/AuthForm">Login</Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li>
                          <Link to="/AuthForm">Profile</Link>
                        </li>
                        <li>
                          <button
                            onClick={handleLogout}
                            style={{
                              width: "100%",
                              textAlign: "left",
                              background: "none",
                              border: "none",
                              padding: "8px 20px",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "#ffffff"
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#666666";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                            }}
                          >
                            Logout
                          </button>
                        </li>
                      </>
                    )}
                  </ul>
                </li>

                <li className="nav-item">
                  <Link to="/contact" className="nav-link">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;